import { useCallback, useMemo, useState } from "react";
import { useAppContext } from "../../providers/ProviderAppContainer";
import { Dialog } from "primereact/dialog";
import TabHeader from "../common/TabHeader";
import { Button } from "primereact/button";
import UserSearch from "../common/UserSearch";
import HasRequiredAuthority from "../dependencies/HasRequiredAuthority";
import { AUTHORITIES } from "../../constants";

export default function DialogAddStudentToBatch({ visible, batchId, students = [], setStudents, closeDialog }) {
    const { requestAPI, showToast } = useAppContext();

    const [selectedUser, setSelectedUser] = useState(null);
    const [assigning, setAssigning] = useState();

    const assignedUserIds = useMemo(() => new Set((students || []).map((student) => Number(student.user_id))), [students]);

    const assignStudent = useCallback(() => {
        if (!selectedUser?.id) return;

        requestAPI({
            requestPath: `batches/${batchId}/users`,
            requestMethod: "POST",
            requestPostBody: { user_id: selectedUser.id },
            setLoading: setAssigning,
            onRequestFailure: () => showToast({ severity: "error", summary: "Failed", detail: "Failed To Assign Student !", life: 2000 }),
            onResponseReceieved: (assigned, responseCode) => {
                if (assigned && responseCode === 201) {
                    showToast({ severity: "success", summary: "Assigned", detail: "Student Added To Batch", life: 1000 });
                    setStudents((prev) => [...(prev || []), assigned]);
                    setSelectedUser(null);
                } else {
                    showToast({ severity: "error", summary: "Failed", detail: assigned?.error || "Failed To Assign Student !", life: 2000 });
                }
            },
        });
    }, [batchId, requestAPI, selectedUser, setStudents, showToast]);

    return (
        <Dialog
            pt={{ content: { className: "overflow-visible" } }}
            header="Add Student To Batch"
            visible={visible}
            className="w-11"
            onHide={() => {
                setSelectedUser(null);
                closeDialog();
            }}
        >
            <TabHeader className="pt-3" title="Add Student" highlights={["Search by name, email or phone"]} />

            <UserSearch
                className="w-full mt-5"
                value={selectedUser}
                onChange={setSelectedUser}
                excludeUserIds={assignedUserIds}
                disabled={assigning}
                floatLabel
                label="Student"
                inputId="batch-student-search"
            />

            <HasRequiredAuthority requiredAuthority={AUTHORITIES.ASSIGN_BATCH_STUDENT}>
                <Button
                    className="mt-3"
                    label="Add"
                    icon="pi pi-plus"
                    severity="warning"
                    disabled={!selectedUser?.id || assigning}
                    loading={assigning}
                    onClick={assignStudent}
                />
            </HasRequiredAuthority>
        </Dialog>
    );
}
